const React = require("react");
const { useSyncee } = require("../context/SynceeContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const DropshippingSynceeConnect = () => {
  const { api, t } = useSyncee();
  const resource = useResource(() => api.getConnection(), [api]);
  const [credentialType, setCredentialType] = React.useState("token");
  const [accessToken, setAccessToken] = React.useState("");
  const [apiKey, setApiKey] = React.useState("");
  const [apiSecret, setApiSecret] = React.useState("");
  const [externalStoreId, setExternalStoreId] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const execute = async (action, success) => {
    setBusy(true); setError(""); setMessage("");
    try { const result = await action(); setMessage(success); await resource.reload(); return result; }
    catch (requestError) { setError(requestError.message); return null; }
    finally { setBusy(false); }
  };
  const connection = resource.data?.connection;
  const signupUrl = resource.data?.signupUrl || "https://app.syncee.com/signup";
  const submit = (event) => {
    event.preventDefault();
    const payload = credentialType === "token" ? { accessToken, externalStoreId } : { apiKey, apiSecret, externalStoreId };
    execute(() => api.connect(payload), t("h_syncee_connected", "Syncee est connecté."));
  };

  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_syncee_connect_title", "Connecter Syncee"),
      description: t("h_syncee_connect_desc", "Utilisez les identifiants API partenaire fournis par Syncee. Elakay les chiffre et ne les réaffiche jamais."),
    }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: false, reload: resource.reload, t },
      h(React.Fragment, null,
        connection ? h("div", { className: "synds-alert" }, h("div", { className: "synds-row synds-between" },
          h("span", null, `${connection.storeName || "Syncee"} · ${connection.tokenHint || "••••••••"}`),
          h(StatusBadge, { status: connection.status, t })
        )) : null,
        message ? h("div", { className: "synds-success" }, message) : null,
        error ? h("div", { className: "synds-alert", role: "alert" }, error) : null,
        h("div", { className: "synds-form" },
          h("h3", null, t("h_syncee_new_account", "Vous n’avez pas encore de compte Syncee ?")),
          h("p", { className: "synds-muted" }, t("h_syncee_signup_desc", "Créez votre compte sur Syncee, puis demandez les identifiants d’intégration adaptés à votre compte.")),
          h("a", { className: "synds-btn secondary", href: signupUrl, target: "_blank", rel: "noopener noreferrer" }, t("h_syncee_signup", "Créer un compte Syncee")),
          h("hr", null),
          h("form", { onSubmit: submit },
            h("div", { className: "synds-field" },
              h("label", { htmlFor: "syncee-credential-type" }, t("h_syncee_auth_type", "Type d’identifiants")),
              h("select", { id: "syncee-credential-type", className: "synds-input", value: credentialType, onChange: (event) => setCredentialType(event.target.value) },
                h("option", { value: "token" }, t("h_syncee_private_token", "Jeton d’accès partenaire")),
                h("option", { value: "api_key" }, t("h_syncee_api_key_mode", "Clé API et secret"))
              )
            ),
            credentialType === "token"
              ? h("div", { className: "synds-field" }, h("label", { htmlFor: "syncee-token" }, t("h_syncee_token", "Jeton Syncee")), h("input", { id: "syncee-token", className: "synds-input", type: "password", required: true, autoComplete: "new-password", value: accessToken, onChange: (event) => setAccessToken(event.target.value) }))
              : h(React.Fragment, null,
                h("div", { className: "synds-field" }, h("label", { htmlFor: "syncee-api-key" }, t("h_syncee_api_key", "Clé API Syncee")), h("input", { id: "syncee-api-key", className: "synds-input", type: "password", required: true, autoComplete: "new-password", value: apiKey, onChange: (event) => setApiKey(event.target.value) })),
                h("div", { className: "synds-field" }, h("label", { htmlFor: "syncee-api-secret" }, t("h_syncee_api_secret", "Secret API Syncee")), h("input", { id: "syncee-api-secret", className: "synds-input", type: "password", autoComplete: "new-password", value: apiSecret, onChange: (event) => setApiSecret(event.target.value) }))
              ),
            h("div", { className: "synds-field" }, h("label", { htmlFor: "syncee-store" }, t("h_syncee_store_id", "Identifiant du store (si requis)")), h("input", { id: "syncee-store", className: "synds-input", value: externalStoreId, onChange: (event) => setExternalStoreId(event.target.value) })),
            h("div", { className: "synds-row" },
              h(Button, { type: "submit", disabled: busy || (credentialType === "token" ? !accessToken.trim() : !apiKey.trim()) }, t("h_syncee_save_credentials", "Enregistrer et tester")),
              connection ? h(Button, { type: "button", variant: "secondary", disabled: busy, onClick: () => execute(api.testConnection, t("h_syncee_test_ok", "Test de connexion réussi.")) }, t("h_syncee_test", "Tester")) : null,
              connection ? h(Button, { type: "button", variant: "danger", disabled: busy, onClick: () => { if (window.confirm(t("h_syncee_confirm_disconnect", "Déconnecter Syncee ? Les produits importés resteront dans Elakay."))) execute(api.disconnect, t("h_syncee_disconnected", "Syncee est déconnecté.")); } }, t("h_syncee_disconnect", "Déconnecter")) : null
            )
          )
        )
      )
    )
  );
};

module.exports = { DropshippingSynceeConnect };
